<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card pt-5 pb-5">
        @for (item of items; track item.id) {
          <div class="card-body pb-0">
            <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
               href="javascript:void(0)" (click)="download(getPdf(item), item.name); $event.preventDefault()">
              <div class="d-flex" style="gap:1rem;">
                <b class="align-content-center" style="min-width:3rem">&nbsp;{{ item.name }}</b>
                <i [class.text-secondary]="isDisabledDownload" [class.text-primary]="!isDisabledDownload">
                  <span class="material-symbols-outlined align-bottom font-4xl">chevron_right</span>
                </i>
              </div>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
